import axios from 'axios';
import { z } from 'zod';

const autoApplyConflictSchema = z.object({
  code: z.literal('AUTO_APPLY_ALREADY_ENABLED'),
  autoApplyWorkflowName: z.string(),
});

/**
 * The chain that already auto-applies, when that is why a save was refused; `undefined` for
 * any other failure, which the caller reports as it always has.
 */
export function readAutoApplyConflict(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) return undefined;

  const parsed = autoApplyConflictSchema.safeParse(error.response?.data);
  return parsed.success ? parsed.data.autoApplyWorkflowName : undefined;
}
